module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/interaktivniMapa-3e7d10fcd8360565543177b8ea6cecd8.svg";